import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'glm-nav-item',
  templateUrl: './nav-item.component.html',
  styleUrls: ['./nav-item.component.css'],
})
export class NavItemComponent implements OnInit {
  constructor(private router: Router) {}

  @Input() icon = 'home';
  @Input() title = '';
  @Input() selected = false;
  @Input() path = '';
  @Input() isDisabled = false;
  @Output() currentroute = new EventEmitter();

  ngOnInit(): void {
    //
  }

  itemClicked() {
    this.router.navigateByUrl(`/${this.path}`);
    this.currentroute.emit(this.path);
    // this.selected = !this.selected;
  }
}
